import { DateStringZ } from "@/types/zod/common";
import { z } from "zod";

export const ObservationSchemaZ = z.object({
	diary_id: z.string().uuid("Diary ID not a valid UUID"),
	observation_id: z.string().uuid("Observation ID not a valid UUID"),
	schedule_id: z.string().uuid("Schedule ID not a valid UUID"),
	form_id: z.string().uuid("Form ID not a valid UUID"),
	contact_id: z.string().uuid().optional(),
	observation_name: z.string(),
	observation_date: DateStringZ,
	shared_attribute_id: z.string().uuid().optional(),
});

export type ObservationSchemaT = z.infer<typeof ObservationSchemaZ>;

export const UpdateObservationSchemaZ = z.object({
	observation_id: z.string().uuid("Observation ID not a valid UUID"),
	diary_id: z.string().uuid("Diary ID not a valid UUID"),
	schedule_id: z.string().uuid("Schedule ID not a valid UUID"),
	form_id: z.string().uuid("Form ID not a valid UUID"),
	contact_id: z.string().uuid().optional(),
	observation_name: z.string().optional(),
	observation_date: DateStringZ.optional(),
	shared_attribute_id: z.string().uuid().optional(),
});

export type UpdateObservationSchemaT = z.infer<typeof UpdateObservationSchemaZ>;
